import { getDirectionality } from "../core/useDirectionality"
import {
    NO_TRANSITION,
    TRANSITION_TO_NEXT,
    TRANSITION_TO_PREVIOUS,
} from './app-transitions'

export const LTR_TRANSITION_TO_NEXT = TRANSITION_TO_NEXT


export const LTR_TRANSITION_TO_PREVIOUS = TRANSITION_TO_PREVIOUS

export const RTL_TRANSITION_TO_NEXT = LTR_TRANSITION_TO_PREVIOUS
export const RTL_TRANSITION_TO_PREVIOUS = LTR_TRANSITION_TO_NEXT

export const getNextTransition = () => {
    const directionality = getDirectionality()

    if (directionality === 'ltr') {
        return LTR_TRANSITION_TO_NEXT
    } else {
        return RTL_TRANSITION_TO_NEXT
    }
}

export const getPreviousTransition = () => {
    const directionality = getDirectionality()
    if (directionality === 'ltr') {
        return LTR_TRANSITION_TO_PREVIOUS
    } else {
        return RTL_TRANSITION_TO_PREVIOUS
    }
}

export const getTransition = (fromIndex, toIndex) => {
    if (fromIndex === toIndex) {
        return NO_TRANSITION
    }

    if (fromIndex < toIndex) {
        return getNextTransition()
    }

    return getPreviousTransition()
}